exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@keyframes shake{3.3333%,30%{transform:translate3d(-1px,0,0)}6.6666%,26.6666%{transform:translate3d(2px,0,0)}10%,16.6666%,23.3333%{transform:translate3d(-4px,0,0)}13.3333%,20%{transform:translate3d(4px,0,0)}27%{transform:translateZ(0)}}#chat-webtrc-agent.audio,#chat-webtrc-customer.audio{display:none}.chat-audio-wraper{text-align:center}.chat-audio-btn.chat-audio-end{border-radius:40px;font-size:20px;position:relative;top:5px;margin-right:20px}.chat-audio-btn.chat-audio-end .glyphicon{position:relative;top:3px;transform:rotate(135deg)}.chat-audio-btn.chat-audio-end.establishing{animation:shake 2.46s cubic-bezier(.36,.07,.19,.97) both infinite}.chat-audio-btn.chat-audio-end.establishing .glyphicon{transform:rotate(0deg)}.chat-audio-label{position:relative;top:8px;font-weight:700}.chat-webrtc-wraper{position:relative}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/postcss-loader!../~/sass-loader/dist/cjs.js!./components/chat/styles/audio.scss
// module id = 1163
// module chunks = 0 1